import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="lectura-significativa"
//
// Avisa UNA sola vez de que la lectura de este contenido cruzó el umbral de significativa
// (TC-134-1.6.2.3). El criterio es el de US-134-1.6.2 y lo sirve el servidor en los valores, no
// está escrito aquí:
//
//   30 s en la página  O  más del 50 % del recorrido  ──▶  POST al endpoint  ──▶  se desconecta
//
// Es una O y no una Y a propósito: un hilo corto se lee entero antes de los treinta segundos y uno
// largo se abandona a la mitad tras varios minutos; las dos son lecturas de verdad y cualquiera de
// las dos señales basta.
//
// El elemento que lo monta no pinta nada: el servidor solo lo emite cuando hay algo que anotar
// (persona con sesión, contenido que no es suyo). Sin JavaScript no ocurre nada, y es correcto —
// los dos hechos que mide solo existen en el navegador.
//
// Deliberadamente NO cuenta tiempo visible sino tiempo de reloj desde que la página se monta: una
// pestaña abierta de fondo media hora cuenta como leída. Es la lectura más simple de "30 s en la
// página" y la que comparte con la consulta de BigQuery de US-134-1.4.8, que tampoco descuenta
// tiempo oculto.
export default class extends Controller {
  static values = {
    // Endpoint que anota la lectura.
    url: String,
    // Id del `Tema` o `Post` leído.
    contenido: Number,
    // El criterio de US-134-1.6.2. Los defectos son los mismos que `LecturaSignificativa::SEGUNDOS`
    // y `::PORCENTAJE_DE_SCROLL`, pero quien manda es lo que sirva el servidor.
    segundos: { type: Number, default: 30 },
    porcentajeDeScroll: { type: Number, default: 50 }
  }

  connect () {
    this.anotada = false
    this.temporizador = setTimeout(() => this.anota(), this.segundosValue * 1000)
    this.alHacerScroll = () => { if (this.pasoDelPorcentaje()) this.anota() }
    window.addEventListener('scroll', this.alHacerScroll, { passive: true })
  }

  disconnect () {
    this.desmonta()
  }

  // Porcentaje recorrido del documento. Con una página que cabe entera en la ventana no hay
  // recorrido posible, así que la señal de scroll no se puede dar y decide el temporizador: darla
  // por cumplida convertiría "abrir" en "leer".
  pasoDelPorcentaje () {
    const recorrible = document.documentElement.scrollHeight - window.innerHeight
    if (recorrible <= 0) return false

    return (window.scrollY / recorrible) * 100 > this.porcentajeDeScrollValue
  }

  // Una vez y solo una: la guarda se pone ANTES de enviar, no después de que responda, porque
  // scroll y temporizador pueden coincidir y dos peticiones en carrera chocarían contra la única
  // de la tabla. Que el envío falle no reabre la puerta — el aviso va sin reintento a propósito:
  // reintentar una lectura que ya pasó no la hace más cierta y sí multiplica el tráfico.
  anota () {
    if (this.anotada) return
    this.anotada = true
    this.desmonta()

    fetch(this.urlValue, {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content ?? ''
      },
      body: JSON.stringify({ contenido_id: this.contenidoValue })
    }).catch(() => {})
  }

  desmonta () {
    clearTimeout(this.temporizador)
    if (this.alHacerScroll) window.removeEventListener('scroll', this.alHacerScroll)
  }
}
